<template>
  <div class="device-repari-records">
    <div class="search-hd">
      <el-form :inline="true" @submit.native.prevent>
        <!-- 配置项 -->
        <el-form-item style="float: right; margin-right: 0">
          <custom-column :code="tableCode" v-model="tableColumn"></custom-column>
        </el-form-item>
        <!-- 搜索项 -->
        <el-form-item style="float: right">
          <search-input v-model="formSearch.search" :placeholder="$t('dms_device_detail_record_repair_records.gdhgdmssbr')" @fetch="onPageChange({ page: 1 })"></search-input>
        </el-form-item>
        <el-form-item style="float: right">
          <switch-button :link="$refs.container"></switch-button>
        </el-form-item>
      </el-form>
    </div>
    <switch-container ref="container" @search="onPageChange({ page: 1 })" @clear="clearFilter('keyword')">
      <el-form :inline="true" label-position="top">
        <!-- 日期 -->
        <el-form-item :label="$t('dms_device_detail_record_repair_records.gong_dan_ri_qi')">
          <custom-date-picker style="width: 100%" v-model="formSearch.timer" type="datetimerange" value-format="YYYY-MM-DD HH:mm:ss" :picker-options="pickerOptionDisAfter"></custom-date-picker>
        </el-form-item>
        <!-- 售后人员  -->
        <el-form-item :label="$t('dms_device_detail_record_repair_records.wei_xiu_ren_yuan')">
          <el-input v-model="formSearch.technicianName" placeholder="" style="width: 100%"></el-input>
        </el-form-item>
        <!-- 售后人员公司  -->
        <el-form-item :label="$t('dms_device_detail_record_repair_records.wxrssgs')">
          <el-input v-model="formSearch.technicianOrgName" placeholder="" style="width: 100%"></el-input>
        </el-form-item>
      </el-form>
    </switch-container>
    <div class="table-bd">
      <custom-table :data="tableList" :column="tableColumn" :max-height="500" @filter="filterChange" @sort="sortChange" :slots="['workOrderCode']">
        <template v-slot:workOrderCode="scope">
          <span class="cell-link" @click="toOrderDetail(scope.row)">{{ scope.row.workOrderCode }}</span>
        </template>
      </custom-table>
    </div>
    <div class="table-page">
      <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import apis from '@/utils/apis.js';
import resetFormSearchMixins from '@/mixins/reset_form_search_mixins.js';

export default {
  props: {
    times: [Array, String],
    deviceInfo: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  mixins: [resetFormSearchMixins],
  components: {},
  data() {
    return {
      tableCode: 'device_repair_records',
      formSearch: {
        pageSize: 20,
        pageNum: 1,
        search: '',
        orderBy: '',
        orderType: '',
        deviceId: '',

        timer: '',
        startDate: '',
        endDate: '',

        technicianOrgName: '',
        technicianName: '',
        workOrderType: '10',
      },
      tableList: [],
      totalRows: null,
    };
  },
  watch: {
    times() {
      this.formSearch.pageNum = 1;
      this.getTableList();
    },
  },
  methods: {
    // 跳转工单详情
    toOrderDetail(row, options = {}) {
      this.jump('/workorder/workOrderDetail', {
        orderType: 'workOrder',
        caseOrderType: row.workOrderType,
        caseOrderId: row.caseOrderId,
        workOrderId: row.workOrderId,
        ...options,
      });
    },
    getTableList() {
      this.$getJSON(apis.DeviceResumeWorkOrderPage, this.getReqData()).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    getReqData() {
      this.formSearch.deviceId = this.deviceInfo.deviceId;
      this.formSearch.startDate = this.formSearch.timer && this.formSearch.timer[0] ? this.formSearch.timer[0] : undefined;
      this.formSearch.endDate = this.formSearch.timer && this.formSearch.timer[1] ? this.formSearch.timer[1] : undefined;
      return {
        ...this.formSearch,
        startDate: this.formSearch.timer && this.formSearch.timer[0] ? `${moment(this.formSearch.timer[0]).format('YYYY-MM-DD')} 00:00:00` : '',
        endDate: this.formSearch.timer && this.formSearch.timer[1] ? `${moment(this.formSearch.timer[1]).format('YYYY-MM-DD')} 23:59:59` : '',
      };
    },
  },
  mounted() {
    this.resetFormSearch = JSON.stringify(this.formSearch);
    this.formSearch.deviceId = this.deviceInfo.deviceId;
    this.getTableColumn();
    this.getTableList();
  },
};
</script>

<style></style>
